/// <amd-module name="Wiki/WitQuery/WitQueryUtils" />

import { ObservableValue } from "VSS/Core/Observable";
import { WorkItemFieldReference } from "Wiki/Clients/Wit/Contracts/WorkItemTracking";

import { ColumnWidth } from "Wiki/WitQuery/WitConstants";
import { CoreFieldRefNames } from "Wit/Common/Generated/Constants";
import { IWorkItemGridColumn } from "Wit/UI/WorkItemGrid";
import { IWorkItemTreeGridColumn } from "Wit/UI/WorkItemTreeGrid";

const columnMaxWidthMap: { [key: string]: number } = {
    [CoreFieldRefNames.Id]: 100,
    [CoreFieldRefNames.WorkItemType]: 250,
    [CoreFieldRefNames.Title]: 99999,
    [CoreFieldRefNames.State]: 125
};

const columnMinWidthMap: { [key: string]: number } = {
    [CoreFieldRefNames.Id]: 100,
    [CoreFieldRefNames.WorkItemType]: 125,
    [CoreFieldRefNames.Title]: 325,
    [CoreFieldRefNames.State]: 90
};

export function getWorkItemGridColumnsForTree(workItemFieldReference: WorkItemFieldReference[]): IWorkItemTreeGridColumn[] {
    const columns: IWorkItemTreeGridColumn[] = [];
    if (workItemFieldReference && workItemFieldReference.length > 0) {
        workItemFieldReference.forEach((wiFieldRef: WorkItemFieldReference) => {
            const fieldRefName = wiFieldRef.referenceName;
            const minWidth = columnMinWidthMap && columnMinWidthMap[fieldRefName] ? columnMinWidthMap[fieldRefName] : ColumnWidth.DefaultMinWidth;
            const maxWidth = columnMaxWidthMap && columnMaxWidthMap[fieldRefName] ? columnMaxWidthMap[fieldRefName] : ColumnWidth.DefaultMaxWidth;
            columns.push({
                key: fieldRefName,
                name: wiFieldRef.name,
                fieldName: fieldRefName,
                minWidth: minWidth,
                maxWidth: maxWidth,
                width: new ObservableValue(minWidth),
                isResizable: true
            } as IWorkItemTreeGridColumn);
        });
    }

    return columns;
}
